import { CartSliceState } from '@/store/cartSlice/type.ts'

export const selectCartTotalQuantity = (state: CartSliceState): number =>
  state.cartItems
    ? Object.values(state.cartItems).reduce(
      (acc, item) => acc + item.quantity,
      0
    )
    : 0
